// Check Warranty Information - Modern JavaScript Implementation
// Based on groca/warranty-script-develop.js but modernized with async/await

document.addEventListener('DOMContentLoaded', function() {
  initCheckWarranty();
});

function initCheckWarranty() {
  // Check for hash in URL (warranty code)
  const hash = window.location.hash;
  if (hash) {
    const code = hash.replace('#', '');
    document.getElementById('check-warranty-input').value = code;
  }

  // Check for auto_submit parameter
  if (window.location.href.includes('auto_submit=true')) {
    const input = document.getElementById('check-warranty-input');
    if (input.value) {
      // Auto-submit after a short delay to ensure UI is ready
      setTimeout(() => {
        checkWarrantyInfo(input.value.trim());
        // Scroll to form
        document.getElementById('check-warranty-form').scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 300);
    }
  }

  // Handle form submission
  const form = document.getElementById('check-warranty-form');
  if (form) {
    form.addEventListener('submit', handleFormSubmit);
  }

  // Clear error on input
  const input = document.getElementById('check-warranty-input');
  if (input) {
    input.addEventListener('input', function() {
      clearFieldError();
    });
  }
}

// Handle form submission
async function handleFormSubmit(e) {
  e.preventDefault();

  // Clear previous errors
  clearFieldError();
  
  const input = document.getElementById('check-warranty-input');
  const searchQuery = input.value.trim();

  // Validate input
  if (!searchQuery) {
    showError('Please enter your warranty code, email, or phone number');
    input.focus();
    return;
  }

  // Check warranty information
  await checkWarrantyInfo(searchQuery);
}

// Check warranty information via API
async function checkWarrantyInfo(searchQuery) {
  const submitButton = document.getElementById('submit-button');
  const loader = document.getElementById('loader');
  const buttonText = document.getElementById('button-text');
  const resultsContainer = document.getElementById('warranty-results');

  // Show loader
  submitButton.disabled = true;
  loader.style.display = 'inline-block';
  buttonText.textContent = 'Searching...';

  // Hide previous results
  resultsContainer.style.display = 'none';
  resultsContainer.innerHTML = '';

  try {
    const response = await fetch(`https://api.halio-sonic.com/v1/registrations?filter=${encodeURIComponent(searchQuery)}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    const result = await response.json();

    if (response.status === 404) {
      displayNoResults();
      return;
    }

    if (!response.ok) {
      throw new Error('Failed to fetch warranty information');
    }

    // Check if we have valid data
    if (!result || !result.registrations || !result.registrations.data) {
      throw new Error('Invalid response format');
    }

    if (result.registrations.data.length === 0) {
      displayNoResults();
      return;
    }

    // Display results
    displayResults(result.registrations.data);

  } catch (error) {
    console.error('Error checking warranty:', error);
    showError('An error occurred while checking warranty information. Please try again.');
  } finally {
    // Reset button
    submitButton.disabled = false;
    loader.style.display = 'none';
    buttonText.textContent = 'Submit';
  }
}

// Display "no results" message
function displayNoResults() {
  const resultsContainer = document.getElementById('warranty-results');
  
  resultsContainer.innerHTML = `
    <div class="no-results">
      <p style="margin: 0 0 10px; font-size: 16px; font-weight: 500;">
        Your information is not registered.
      </p>
      <p style="margin: 0; font-size: 14px;">
        Would you like to <a href="/pages/warranty-registration">register your warranty now</a>?
      </p>
    </div>
  `;
  
  resultsContainer.style.display = 'block';
  
  // Scroll to results
  resultsContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

// Display warranty results
function displayResults(registrations) {
  const resultsContainer = document.getElementById('warranty-results');
  
  resultsContainer.innerHTML = '';
  
  registrations.forEach(registration => {
    const attributes = registration.attributes;
    const defaultImage = 'https://cdn.shopify.com/s/files/1/2025/2313/files/default-img_480x480.jpg?v=1636665918';
    
    const resultItem = document.createElement('div');
    resultItem.className = 'warranty-result-item';
    
    resultItem.innerHTML = `
      <img 
        src="${attributes.previewImage || defaultImage}" 
        alt="Product"
        class="product-image"
        onerror="this.src='${defaultImage}'"
      >
      
      <div class="warranty-code-display">${attributes.code}</div>
      
      <div class="warranty-details">
        <div class="warranty-detail-row">
          <span class="label">Order Number:</span>
          <span class="value">${attributes.orderNumber || 'N/A'}</span>
        </div>
        
        <div class="warranty-detail-row">
          <span class="label">Purchase date:</span>
          <span class="value">${attributes.purchaseDate || 'N/A'}</span>
        </div>
        
        <div class="warranty-detail-row">
          <span class="label">Bought at:</span>
          <span class="value">${attributes.place?.data?.attributes?.name || 'N/A'}</span>
        </div>
      </div>
    `;
    
    resultsContainer.appendChild(resultItem);
  });
  
  resultsContainer.style.display = 'block';
  
  // Scroll to results
  resultsContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

// Show error message
function showError(message) {
  const errorElement = document.getElementById('error-search');
  const input = document.getElementById('check-warranty-input');
  
  if (errorElement) {
    errorElement.textContent = message;
    errorElement.style.display = 'block';
  }
  
  if (input) {
    input.classList.add('has-error');
  }
}

// Clear field error
function clearFieldError() {
  const errorElement = document.getElementById('error-search');
  const input = document.getElementById('check-warranty-input');
  
  if (errorElement) {
    errorElement.style.display = 'none';
    errorElement.textContent = '';
  }
  
  if (input) {
    input.classList.remove('has-error');
  }
}
